import {Loading} from '@baidu/luffy-comp-loading';
export default Loading;
